import KsaFlag from "./flags/ksa-flag.svg?react";
import ArrowUpIcon from "./icons/arrow-up.svg?react";
import BoxIcon from "./icons/box.svg?react";
import CheckIcon from "./icons/check.svg?react";
import CancelIcon from "./icons/close-circle.svg?react";
import CloseIcon from "./icons/close.svg?react";
import CopyIcon from "./icons/copy.svg?react";
import CreditCardIcon from "./icons/credit-card.svg?react";
import ErrorCircleIcon from "./icons/error-circle.svg?react";
import FadeStaggerCirclesIcon from "./icons/fade-stagger-circles.svg?react";
import FailedIcon from "./icons/failed.svg?react";
import HashIcon from "./icons/hash.svg?react";
import InfoCircleIcon from "./icons/info-circle.svg?react";
import LocationIcon from "./icons/location.svg?react";
import MoneyStackIcon from "./icons/money-stack.svg?react";
import MoneyTickIcon from "./icons/money-tick.svg?react";
import MoneyIcon from "./icons/money.svg?react";
import NavigateIcon from "./icons/navigate.svg?react";
import RefundBadgeIcon from "./icons/refund-badge.svg?react";
import RialSymbolIcon from "./icons/ryal-symbol.svg?react";
import ShieldIcon from "./icons/shield.svg?react";
import ShopIcon from "./icons/shop.svg?react";
import StackedCardsIcon from "./icons/stacked-cards.svg?react";
import StarIcon from "./icons/star.svg?react";
import SuccessIcon from "./icons/success.svg?react";
import FastTruckIcon from "./icons/truck-fast.svg?react";
import TruckIcon from "./icons/truck.svg?react";
import UserTagIcon from "./icons/user-tag.svg?react";
import XIcon from "./icons/x.svg?react";
import AmexIcon from "./logos/amex.svg?react";
import FacebookIcon from "./logos/facebook.svg?react";
import LinkedinIcon from "./logos/linkedin.svg?react";
import MadaIcon from "./logos/mada.svg?react";
import MastercardIcon from "./logos/mastercard.svg?react";
import SaudiBusinessCenterIcon from "./logos/saudi-business-center.svg?react";
import TabbyLogo from "./logos/tabby-logo.svg?react";
import TamaraLogo from "./logos/tamara-logo.svg?react";
import TwitterIcon from "./logos/twitter.svg?react";
import VisaIcon from "./logos/visa.svg?react";

// other formats
import applePayImage from "./logos/apple-pay.png";
import DamenkomLogo from "./logos/damenkom-logo.png";
import stcImage from "./logos/stc.png";

function StcIcon({ className }: { className?: string }) {
  return <img src={stcImage} alt="Stc" className={className} />;
}

function ApplePayIcon({ className }: { className?: string }) {
  return <img src={applePayImage} alt="Apple Pay" className={className} />;
}

function DamenkomLogoIcon({ className }: { className?: string }) {
  return <img src={DamenkomLogo} alt="Logo" className={className} />;
}

export {
  AmexIcon,
  ApplePayIcon,
  ArrowUpIcon,
  BoxIcon,
  CancelIcon,
  CheckIcon,
  CloseIcon,
  CopyIcon,
  CreditCardIcon,
  DamenkomLogo,
  DamenkomLogoIcon,
  ErrorCircleIcon,
  FacebookIcon,
  FadeStaggerCirclesIcon,
  FailedIcon,
  FastTruckIcon,
  HashIcon,
  InfoCircleIcon,
  KsaFlag,
  LinkedinIcon,
  LocationIcon,
  MadaIcon,
  MastercardIcon,
  MoneyIcon,
  MoneyStackIcon,
  MoneyTickIcon,
  NavigateIcon,
  RefundBadgeIcon,
  RialSymbolIcon,
  SaudiBusinessCenterIcon,
  ShieldIcon,
  ShopIcon,
  StackedCardsIcon,
  StarIcon,
  StcIcon,
  SuccessIcon,
  TabbyLogo,
  TamaraLogo,
  TruckIcon,
  TwitterIcon,
  UserTagIcon,
  VisaIcon,
  XIcon,
};
